module.exports = __webpack_public_path__ + "img/Theoretical-01.de6dc8bc.jpg";